export function checkStorageValue(value){return['true','false'].indexOf(value)>=0?JSON.parse(value):value;}